<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Update Details</h4>
</div>
<div class="modal-body">
    <div *ngIf="dataLoaded">
        <form [formGroup]="form" novalidate autocomplete="off">
            <fieldset>
                <div class="row">
                    <div class="col-sm-3 col-md-2 mvd_form-group">
                        <label>UC Designation</label>
                        <input type="checkbox" formControlName="isProtected">
                    </div>

                    <ng-container formGroupName="details" *ngIf="form.get('isProtected').value">
                        <div class="col-sm-4 col-md-3 mvd_form-group">
                            <label class="required" title="* Required">Sponsoring Agency</label>
                            <input class="mvd_form-control" type="text" formControlName="sponsoringAgency">
                        </div>
                        <div class="col-sm-2 mvd_form-group">
                            <label>Special Alert</label>
                            <input type="checkbox" formControlName="specialAlert">
                        </div>
                    </ng-container>
                </div>
            </fieldset>
        </form>
    </div>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" data-bs-dismiss="modal" (click)="cancel()">Cancel</button>
        <button class="btn--primary" type="submit" (click)="save()" [disabled]="isFormInvalid">Save</button>
    </div>
</div>
